import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9db95366"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-shadow-dimensions d-flex flex-wrap align-items-center" }
const _hoisted_2 = { class: "box-shadow-dimension" }
const _hoisted_3 = { class: "box-shadow-dimension" }
const _hoisted_4 = { class: "box-shadow-dimension" }
const _hoisted_5 = { class: "box-shadow-dimension" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CssDimensionEditor = _resolveComponent("CssDimensionEditor")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_ColorSolidEditor = _resolveComponent("ColorSolidEditor")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CssDimensionEditor, {
              modelValue: _ctx.localDto.h_offset,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDto.h_offset) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('cms.boxShadowHOffset'),
              name: `${_ctx.name} ${_ctx.$t('cms.boxShadowHOffset')}`,
              errors: _ctx.errors,
              allowDisable: false,
              fixedUnit: _ctx.CssUnitEnum.PX
            }, null, 8, ["modelValue", "label", "name", "errors", "fixedUnit", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_CssDimensionEditor, {
              modelValue: _ctx.localDto.v_offset,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDto.v_offset) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('cms.boxShadowVOffset'),
              name: `${_ctx.name} ${_ctx.$t('cms.boxShadowVOffset')}`,
              errors: _ctx.errors,
              allowDisable: false,
              fixedUnit: _ctx.CssUnitEnum.PX
            }, null, 8, ["modelValue", "label", "name", "errors", "fixedUnit", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_CssDimensionEditor, {
              modelValue: _ctx.localDto.blur_radius,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localDto.blur_radius) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('cms.boxShadowBlurRadius'),
              name: `${_ctx.name} ${_ctx.$t('cms.boxShadowBlurRadius')}`,
              errors: _ctx.errors,
              min: 0,
              allowDisable: false,
              allowEmptyValue: true,
              placeholder: _ctx.$t('default'),
              fixedUnit: _ctx.CssUnitEnum.PX
            }, null, 8, ["modelValue", "label", "name", "errors", "placeholder", "fixedUnit", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CssDimensionEditor, {
              modelValue: _ctx.localDto.spread_radius,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localDto.spread_radius) = $event)),
                _ctx.emitModelChanged
              ],
              label: _ctx.$t('cms.boxShadowSpreadRadius'),
              name: `${_ctx.name} ${_ctx.$t('cms.boxShadowSpreadRadius')}`,
              errors: _ctx.errors,
              allowDisable: false,
              allowEmptyValue: true,
              placeholder: _ctx.$t('default'),
              fixedUnit: _ctx.CssUnitEnum.PX
            }, null, 8, ["modelValue", "label", "name", "errors", "placeholder", "fixedUnit", "onUpdate:modelValue"])
          ]),
          _createVNode(_component_InputCheckboxBoolean, {
            modelValue: _ctx.localDto.is_inset,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localDto.is_inset) = $event)),
              _ctx.emitModelChanged
            ],
            label: _ctx.$t('cms.boxShadowInset'),
            name: `${_ctx.name} ${_ctx.$t('cms.boxShadowInset')}`,
            errors: _ctx.errors,
            class: "box-shadow-inset"
          }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
        ]),
        _createVNode(_component_ColorSolidEditor, {
          modelValue: _ctx.localDto.color,
          label: _ctx.$t('cms.boxShadowColor'),
          name: _ctx.name,
          errors: _ctx.errors,
          isBackground: true,
          allowEmpty: true,
          "onUpdate:modelValue": _ctx.onColorChanged
        }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}